// src/App.js
import { Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import NotFound from "./pages/NotFound";
import Footer from "./components/Footer";
import OurServices from "./pages/Services";
import ServiceDetails from "./components/ServiceDetails";
import Contact from "./pages/Contact";
import Profile from "./components/Profile";
import ProfileDetails from "./components/ProfileDetails";
import ScrollToTop from "./components/ScrollToTop";

function App() {
	return (
		<div className="appContainer">
			<Header />
			<main className="mainContent">
				<ScrollToTop />
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/about" element={<AboutUs />} />
					<Route path="/services" element={<OurServices />} />
					<Route path="/services/:serviceId" element={<ServiceDetails />} />
					<Route path="/contact" element={<Contact />} />
					<Route path="/profile" element={<Profile />} />
					<Route path="/profileDetails" element={<ProfileDetails />} />
					<Route path="*" element={<NotFound />} />
				</Routes>
			</main>
			<Footer />
		</div>
	);
}

export default App;
